export default __webpack_public_path__ + "static/media/dot.a49a7c47.svg";